module.exports = __webpack_public_path__ + "static/media/10UNOHRLLS8.d5e96ab3.jpg";